<template>
  <sup class="bear-remark-link" @click="scrollToTarget">
    <slot name="default" />
  </sup>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'BearRemarkLink',
  props: {
    targetId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['$vm'])
  },
  methods: {
    scrollToTarget () {
      const { targetId } = this
      if (targetId) {
        const targetNode = document.getElementById(targetId)
        this.$vm.$el.scrollTo({
          top: targetNode.offsetTop - 100,
          behavior: 'smooth'
        })
        targetNode.style = 'border: 1px dashed red; background: #fff2f4;'
        setTimeout(() => {
          targetNode.style = ''
        }, 1500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bear-remark-link {
  cursor: pointer;
  &:hover {
    color: black;
  }
}  
</style>